export const api="https://api.555mix.com/api";

// export const api="http://192.168.99.159:8080/api";